import angular from 'angular';
import moment from 'moment-timezone';
import { isNil } from 'lodash';

import {} from './od-footer.less';

module.exports = angular.module('market.components.od-footer', [])
.component('odFooter', {
  bindings: {
    topBorder: '<?',
  },
  template: require('./od-footer.jade')(),
  controller: class {
    constructor(Segment) {
      this.showTopBorder = isNil(this.topBorder) ? true : this.topBorder;
      this.currentYear = moment().year();
      this.Segment = Segment;
    }

    trackOpendorMortgageLink(){
      this.Segment.track('clicked mortgage link', {
        page: 'homepage', pageLocation: 'footer'
      });
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-footer.js
 **/